import React from 'react';
import SharedProfilesHeader from './SharedProfilesHeader';
import useOrganizationMedicalProfiles from '../../../hooks/api/useOrganizationMedicalProfiles';

export type SelectedClientProfilesHeaderOwnProps = {
    selectedProfileIds: string[];
};

export type SelectedClientProfilesHeaderProps = SelectedClientProfilesHeaderOwnProps;

const SelectedClientProfilesHeader: React.FC<SelectedClientProfilesHeaderProps> = (props) => {
    const { organizationMedicalProfiles, isLoadingOrganizationMedicalProfiles } = useOrganizationMedicalProfiles();

    return (
        <SharedProfilesHeader
            {...props}
            profiles={organizationMedicalProfiles}
            isLoadingProfiles={isLoadingOrganizationMedicalProfiles}
        />
    );
};

export default React.memo(SelectedClientProfilesHeader);
